
import { cn } from "@/lib/utils";
import { CertificateQRCode } from "../CertificateQRCode";

interface CertificateFooterProps {
  style: Record<string, string>;
  userName: string;
  shareUrl: string;
}

export function CertificateFooter({ style, userName, shareUrl }: CertificateFooterProps) {
  return (
    <div className="text-center space-y-1 w-full mt-1 sm:mt-2 animate-fade-in" style={{ animationDelay: "600ms" }}>
      <div className={cn(
        "w-12 sm:w-20 md:w-32 h-0.5 mx-auto mb-1",
        `bg-gradient-to-r ${style.gradient}`
      )} />
      <p className={cn("text-[10px] sm:text-xs", style.contentFont)}>
        Self-Attested By
      </p>
      <p className={cn(
        style.titleFont,
        style.accent,
        "text-sm sm:text-base md:text-xl",
        "transition-all duration-300 hover:scale-105"
      )}>
        {userName}
      </p>
      <div className="mt-1 sm:mt-2 md:mt-4 flex flex-col items-center animate-fade-in" style={{ animationDelay: "700ms" }}>
        <CertificateQRCode url={shareUrl} size={32} className="block sm:hidden transition-all duration-300 hover:scale-110" />
        <CertificateQRCode url={shareUrl} size={48} className="hidden sm:block md:hidden transition-all duration-300 hover:scale-110" />
        <CertificateQRCode url={shareUrl} size={64} className="hidden md:block transition-all duration-300 hover:scale-110" />
        <p className="text-[8px] sm:text-[10px] md:text-xs mt-0.5 sm:mt-1">
          Scan to create your own certificate
        </p>
      </div>
      <p className="text-[8px] sm:text-[10px] md:text-xs mt-0.5 sm:mt-1">
        Self-certified through GoalDigger
      </p>
    </div>
  );
}
